import React from 'react';

function Contact(props) {
    return (
        <div id="Contact" className="contact">
            <h2>GET IN TOUCH!</h2>
            <p>Whether you have an idea for a project or just want to chat, feel free to shoot me an email!</p>
            <button><a href="mailto:shradhaagarwal386@gmail.com">Say Hello</a></button>
        </div>
    );
}

export default Contact;
